import React from 'react';
import Hero from '../components/Hero';
import AboutPreview from '../components/AboutPreview';
import ServicesPreview from '../components/ServicesPreview';
import CTASection from '../components/CTASection';
import SEO from '../components/SEO';
import '../components/PageTransitions.css';

const Home = () => {
  return (
    <>
      <SEO
        title="Ana Sayfa"
        description="LYSEP CORPORATION - Yazılım alanında profesyonel çözümler sunuyoruz. Otomotiv çözümleri, web siteleri, yazılım geliştirme ve teknoloji hizmetleri."
        keywords="LYSEP, yazılım geliştirme, teknoloji çözümleri, web tasarım, otomotiv yazılımları, OBD screen, QR menü sistemi, masaüstü uygulama geliştirme"
        path="/"
      />
      <Hero />
      <AboutPreview />
      <ServicesPreview />
      <CTASection />
    </>
  );
};

export default Home;

